import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePageComponent } from '../../../base-page.component';
import { Machine } from '../../../shared/models/machine.model';
import { MachineModuleService } from '../../../shared/services/machineModule.service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  templateUrl: './machines-list-page.component.html',
  standalone: false
})
export class MachinesListPageComponent extends BasePageComponent implements OnInit {
  public machines: Machine[] = [];
  public pageNumber = 1;
  public pageSize = 50;
  public hasMore = true;
  search = new FormControl();

  constructor(private route: ActivatedRoute, private router: Router, private machinesService: MachineModuleService, location: Location) {
    super(location);
  }

  ngOnInit() {
    this.loadMachines();
    this.search.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((value) => this.onSearch(value));
  }

  loadMachines(): void {
    if (this.loading || !this.hasMore) {
      return;
    }

    this.loading = true;
    this.machinesService.getMachines(this.pageNumber, this.pageSize, this.query).subscribe(
      (machines) => {
        this.hasMore = machines.length === this.pageSize;
        this.loading = false;
        this.machines.push(...machines);
      },
      () => (this.loading = false)
    );
  }

  loadMore(): void {
    if (!this.loading && this.hasMore) {
      this.pageNumber++;
      this.loadMachines();
    }
  }

  onSearch(searchTerm: string): void {
    this.query = searchTerm;
    this.pageNumber = 1;
    this.machines = [];
    this.hasMore = true;
    this.loadMachines();
  }

  public openMachine(machine: Machine) {
    this.router.navigate([this.appRoute, 'machines', machine.serialNumber]);
  }

  goToBack() {
    this.router.navigate([this.appRoute]);
  }
}
